import { createAction } from '@ngrx/store'

export const openEventDrawer = createAction('[Shell] Open Event Drawer')
export const closeEventDrawer = createAction('[Shell] Close Event Drawe')
